import React from 'react';
import { Text, View, StyleSheet } from 'react-native';
import { COLOR, FONT, FONT_SIZE, THEME, THEME_DARK, __WEB__ } from '../../../constants/styles';
import { OPComponent } from '../../components';

import ScheduleCal, { dateIsPast, isInRange } from '../../components/schedule_cal';

export default class OnCallCal extends OPComponent {
  constructor(props) {
    super(props);

    this.state = {
      selectedDate: null,
      selectedRange: null,
    };
  }

  componentDidMount() {}

  componentWillUnmount() {}

  calDisplayTextAsOffRangeForDate = (date) => {
    return !!dateIsPast(date);
  };

  calCellBGClassForDate = (date) => {
    let className = '';
    if (isInRange(date, this.state.selectedRange)) {
      className += ' rbc-today';
    }
    return className;
  };

  handleSelectedDate = (selectedDate) => {
    this.setState({ selectedDate });
    this.props.onSelectedDate?.(selectedDate);
  };
  handleSelectedRange = (selectedRange) => {
    this.setState({ selectedRange });
    this.props.onSelectedRange?.(selectedRange);
  };

  render() {
    const props = this.props;

    return (
      <View style={styles.container}>
        <ScheduleCal
          className="rbc-schedule"
          calDisplayTextAsOffRangeForDate={this.calDisplayTextAsOffRangeForDate}
          calCellBGClassForDate={this.calCellBGClassForDate}
          onSelectedDate={this.handleSelectedDate}
          onSelectedRange={this.handleSelectedRange}
          disablePastSelect={false}
          multi={true}
          events={props.events}
          onHeight={this.props.onHeight}
          dotStyle={styles.dot}
        />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {},
  dot: {
    width: 10,
    height: 10,
    borderRadius: 5,
    backgroundColor: COLOR.greenColor,
    top: 1,
    right: 5,
  },
});
